import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

// Nilvera kurumsal renk paleti
//  - primary   : Logo laciverti
//  - secondary : Kurumsal gök mavisi (vurgu / etkileşim rengi)
export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#091F2D",
        secondary: "#0084CC",
        accent: "#00A5EF",
        error: "#DC2626",
        info: "#0084CC",
        success: "#16A34A",
        warning: "#D97706"
      }
    }
  }
});
